/** @jsx jsx */
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { StepperType } from 'components/stepper'
import { goToMyAccount } from 'utils/navigate'
import { isContentLocalized, getMessageFormatter } from 'utils/content'
import styled from '@emotion/styled'
import { jsx, css } from '@emotion/core'
import { serverData } from '../../utils/server-data'
import { BackButton, CloseButton } from '../buttons'
import { connect } from 'react-redux'
import { isContentAvailable } from 'utils/screens/common'
import { modalTitleCss } from './style'

// FIXME z-index is a bad, bad hack that will bite us in future
const NavWrapper = styled.div`
  position: relative;
  z-index: 999;
  width: 100%;
  display: flex;

  .ppvx_modal-header__action {
    margin: 0.75rem;
  }
`

/* eslint-disable no-nested-ternary */
const navWrapperCss = ({ isShowBackBtn, isShowCloseBtn }) => css`
  justify-content: ${isShowBackBtn && isShowCloseBtn
    ? 'space-between'
    : isShowBackBtn
    ? 'flex-start'
    : 'flex-end'};
`

const noop = () => {}

function ModalNav(props) {
  const { stepper, worldReady, onBack, onClose, isSessionExpired, retryHandler, modalTitleId } =
    props

  const { isShowBackBtn, onBackBtnClick } = useMemo(() => {
    let _isShowBackBtn, _onBackBtnClick

    // back button is controlled by props.stepper, in whose absence it's controlled by the presence of props.onBack
    if (typeof stepper === 'object') {
      const { isFirstStep = noop, isLastStep = noop, previousStep = noop } = stepper

      // if back button is not disabled by onBack===null, first step always has a back button according to UED
      // back button will be hidden if it's on a Retry / Retry Later screen
      _isShowBackBtn = onBack === null ? false : (isFirstStep() || !isLastStep()) && !retryHandler
      _onBackBtnClick = isFirstStep() ? onBack || goToMyAccount : previousStep
    } else {
      _isShowBackBtn = !!onBack
      _onBackBtnClick = onBack || (() => {})
    }

    // Hide back button if session is expired
    _isShowBackBtn = !isSessionExpired && _isShowBackBtn

    return { isShowBackBtn: _isShowBackBtn, onBackBtnClick: _onBackBtnClick }
  }, [stepper, onBack, isSessionExpired, retryHandler])

  const onCloseBtnClick = onClose || goToMyAccount
  const isShowCloseBtn = !serverData.isMobileNative

  // TODO assign label as <Message id='common.nav.back' /> once translation is done
  let label,
    closeLabel = '',
    modalTitle = ''
  if (worldReady) {
    const formatMessage = getMessageFormatter(worldReady)
    if (isShowBackBtn) {
      label = formatMessage('common.nav.back')
      label = isContentLocalized(label) ? label : 'Back'
    }
    closeLabel = formatMessage('funding.button.close')
    const formattedModalTitle = formatMessage(modalTitleId)
    modalTitle = isContentAvailable(formattedModalTitle) ? formattedModalTitle : ''
  }

  return (
    <NavWrapper css={navWrapperCss({ isShowBackBtn, isShowCloseBtn })}>
      <div className="ppvx_modal-header__action">
        {isShowBackBtn && <BackButton onClick={onBackBtnClick} backtext={label} />}
      </div>
      {modalTitle && (
        <div className="ppvx_modal-header__title" css={modalTitleCss}>
          {modalTitle}
        </div>
      )}
      {isShowCloseBtn && <CloseButton onClick={onCloseBtnClick} ariaLabel={closeLabel} />}
    </NavWrapper>
  )
}

const stateProps = ({ common }, { fetchRetry }) => {
  const { isSessionExpired } = common || {}
  const { retryHandler } = fetchRetry || {}

  return {
    isSessionExpired,
    retryHandler,
  }
}

ModalNav.propTypes = {
  stepper: StepperType,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  worldReady: PropTypes.object,
  isSessionExpired: PropTypes.bool,
  retryHandler: PropTypes.func,
  modalTitleId: PropTypes.string,
}

export default connect(stateProps)(ModalNav)
